import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/hedges')({
  component: HedgesLayout,
})

function HedgesLayout() {
  return <Outlet />
}
